import { useGetAllWorkflowEventsQuery } from '@/slices/workflowEventSlice';

// Get all milestone events, e.g. event.isMilestone === true
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const CODES = [
	// keep this for reference
	'QUOTE_APPROVED',
	'QUOTE_CHANGES_REQUESTED',
	'QUOTE_CANCELED',
	'INVOICE_OVERDUE',
	'INVOICE_CHANGES_REQUESTED',
	'INVOICE_PAID',
	'JOB_COMPLETED',
	'JOB_CHANGES_REQUESTED',
	'JOB_ASSIGNED',
	'JOB_CREATED',
	'QUOTE_SENT',
	'QUOTE_VIEWED',
	'INVOICE_SENT',
	'INVOICE_VIEWED',
	'OTHER',
];

const useMilestoneEvents = () => {
	const { data: milestoneEvents, isLoading: isLoadingMilestoneEvents } =
		useGetAllWorkflowEventsQuery(undefined, {
			selectFromResult: ({ data, isLoading, isError }) => {
				const milestoneEvents = data?.filter(
					(event) => event?.isMilestone,
				);

				return { data: milestoneEvents, isLoading, isError };
			},
		});

	return { milestoneEvents, isLoadingMilestoneEvents };
};

export default useMilestoneEvents;
